<template>
  <div class="app">
    <header-item></header-item>
    <el-row class="page-frame">
      <el-col :span="4">
        <menu-item></menu-item>
      </el-col>
      <el-col :span="20">
        <div class="content">
          <router-view />
        </div>
      </el-col>
    </el-row>
  </div>
</template>
  
<script setup>
import { onMounted } from "vue";
import { useUserStore } from "@/stores/user";
import HeaderItem from "./components/header-item.vue";
import MenuItem from "./components/menu-item.vue";

// 进入后台时拉一次用户档案，给菜单/路由的权限判断用
const userStore = useUserStore();
onMounted(() => {
  if (!userStore.userInfoLoaded) {
    userStore.fetchUserInfo();
  }
});
</script>

<style scoped lang="less">
.app {
  background-color: @lightgrey;
  width: 100%;
  height: 100%;
  position: absolute;
  .page-frame {
    position: absolute;
    top: 60px;
    bottom: 20px;
    width: 1220px;
    left: 50%;
  transform: translateX(-50%);
    .content {
      width: 920px;
      position: relative;
      top: 20px;
      bottom: 20px;
      left: 30px;
    }
  }
}

</style>